import React from 'react';
import Link from 'gatsby-link';
import './see-more.css';
import PropTypes from "prop-types";

import arrow from '../../images/arrow.svg';

class SeeMore extends React.Component {

  static propTypes = {
    link: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }

  static defaultProps = {
    link: "/",
    content: "See More"
  }

  render() {
    return (
      <div className="row one-margin-top">
        <div className={"col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10 see-more"}>
        <Link to={this.props.link}>{this.props.content}</Link>
          <img src={arrow} alt="arrow pointing right"/>
        </div>
      </div>
    )
  }
}

export default SeeMore;



// WEBPACK FOOTER //
// ./src/components/SeeMore/see-more.js